import React, { useEffect, useMemo, useState } from "react";
import ArchivedLeaveCancellationTable from './Components/ArchivedLeaveCancellationTable'
import LeaveCancellationRequestTable from './Components/LeaveCancellationRequestTable'

const LeaveCancellationRequest = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    return (
        <>
            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
                <div className="row g-3">
                    <div className="col-sm-12">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <h3 className="fw-bold mb-0">Pending Cancellation Request</h3>
                            {/* <div className="col-auto d-flex w-sm-100">
                            <button type="button" className="btn btn-dark btn-set-task w-sm-100" data-bs-toggle="modal" data-bs-target="#leaveadd">Add Leave</button>
                        </div> */}
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <LeaveCancellationRequestTable
                                    onDecision={() => setRefreshKey(prev => prev + 1)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
                <div className="row g-3">
                    <div className="col-sm-12">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <h3 className="fw-bold mb-0">Cancellation Request History</h3>
                            {/* <div className="col-auto d-flex w-sm-100">
                            <button type="button" className="btn btn-dark btn-set-task w-sm-100" data-bs-toggle="modal" data-bs-target="#leaveadd">Add Leave</button>
                        </div> */}
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <ArchivedLeaveCancellationTable
                                    refreshKey={refreshKey}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveCancellationRequest